import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { AUTH0_CONFIG } from "./auth0-config";
import { Auth0InterceptorService } from "./auth0-interceptor.service";
import { SharedConfigService } from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";
import { LG_AUTHENTICATION_SERVICE } from "@logex/framework/lg-application";
import { Auth0AuthenticationService } from "./auth0-authentication.service";

@NgModule({
    imports: []
})
export class SharedUtilAuthorizationModule {
    static forRoot(): ModuleWithProviders<SharedUtilAuthorizationModule> {
        return {
            ngModule: SharedUtilAuthorizationModule,
            providers: [
                {
                    provide: AUTH0_CONFIG,
                    useFactory: (configService: SharedConfigService) =>
                        configService.getAppConfiguration().ready.then(config => ({
                            redirectUri: `${location.origin}/callback`,
                            ...configService.getConfiguration()?.auth0
                        })),
                    deps: [SharedConfigService]
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: Auth0InterceptorService,
                    multi: true
                },
                {
                    provide: LG_AUTHENTICATION_SERVICE,
                    useClass: Auth0AuthenticationService
                }
            ]
        };
    }
}
